import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import every from 'lodash/every';

import {IDType} from 'utils/prop-types';

import Spinner from 'scripts/components/Spinner';

import QuestionnaireList from './QuestionnaireList';
import MarkDown from 'scripts/components/MarkDown';


const AllComplete = () => (
    <div className="center-align">
        <MarkDown className="questionnaires-completed" text={window.COVSOCIAL_COMPLETED} />
    </div>
);


/**
 * Renders the Questionnaire list if questionnaires are available, a message otherwise
 */
const Questionnaires = ({questionnaires, allComplete}) => {
    if (questionnaires === null) {
        return <Spinner />;
    } else if (allComplete) {
        return <AllComplete />;
    }

    return <QuestionnaireList questionnaires={questionnaires} />;
};

Questionnaires.propTypes = {
    questionnaires: PropTypes.arrayOf(IDType),
};

Questionnaires.defaultProps = {
    questionnaires: null,
};

const mapStateToProps = ({questionnaire}) => ({
    questionnaires: questionnaire.ids,
    allComplete: every(questionnaire.ids, id => questionnaire[id].completed),
});

export default connect(mapStateToProps, {})(Questionnaires);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/Questionnaires.js